export const ConfigUser = {
  PERMISSIONS: {
    PRICE: 'PRECIO',
    SHIPPING: 'FLETE',
    STOCK: 'STOCK',
    CREDIT: 'CREDITO',
    SALE_ENTERPRISE: 'UEMPRESA',
    SALE_CUSTOMER: 'UCLIENTE',
    ADMIN: 'ADMIN',
    SALE_NOTE: 'MDESPACHO',
    REIMPRESION: 'REIMPRESION',
    ANNULMENT: 'ANULACION',
    REIMPRESION_CARGIO: 'REIMPRESIONCARGIO',
    OPTION_FOURTEEN_AGORASHOP: 'OPTION_FOURTEEN_AGORASHOP',
    CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
    RETURN_ENTITIES: 'RETURN_ENTITIES',
    ALLOW_SELLER_CANCELLATION: 'ALLOW_SELLER_CANCELLATION',
    PHOTOS_APP_PICKING: 'PHOTOS_APP_PICKING',
    LEVEL: () => [
      { value: 'NIVEL_1', viewValue: false, edit: false, name: 'Nivel 1' },
      { value: 'NIVEL_2', viewValue: true, edit: false, name: 'Nivel 2' },
      { value: 'NIVEL_3', viewValue: true, edit: true, name: 'Nivel 3' },
    ]
  },
  userSupport: 'SOPORTE',
  AUTHORIZATION: {
    TYPE: {
      FREIGHT_MODIFY: 'FREIGHT_MODIFY',
      SALE_WITHOUT_STOCK: 'SALE_WITHOUT_STOCK',
      FREIGHT_DELETE: 'FREIGHT_DELETE',
      PRICE_MODIFY: 'PRICE_MODIFY'
    }
  }
};
